import { formatHours, formatRating, type WellnessRelationship } from "@consistency-circle/shared";

import type { WebWellnessMetric } from "../constants";

export function WellnessRelationshipCard({
  metric,
  relationship,
}: {
  readonly metric: WebWellnessMetric;
  readonly relationship: WellnessRelationship;
}) {
  const delta =
    relationship.highMoodAverage !== null && relationship.lowMoodAverage !== null
      ? relationship.highMoodAverage - relationship.lowMoodAverage
      : null;
  const formatter = metric.kind === "hours" ? formatHours : formatRating;

  return (
    <div className="space-y-3 rounded-xl border border-border bg-card p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm font-medium">
          <span className="text-primary">
            <metric.Icon className="h-4 w-4" />
          </span>
          {metric.label}
        </div>
        <span className="text-xs text-muted-foreground">{relationship.days} days</span>
      </div>

      <div className="grid grid-cols-2 gap-2 text-sm">
        <div className="rounded-lg bg-muted px-3 py-2">
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground">Mood 4-5</p>
          <p className="mt-1 font-semibold tabular-nums">
            {formatter(relationship.highMoodAverage)}
          </p>
        </div>
        <div className="rounded-lg bg-muted px-3 py-2">
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground">Mood 1-3</p>
          <p className="mt-1 font-semibold tabular-nums">
            {formatter(relationship.lowMoodAverage)}
          </p>
        </div>
      </div>

      <p className="text-xs text-muted-foreground">
        {relationship.days < 3 || delta === null
          ? "Log a few more days to compare."
          : delta > 0
            ? `Higher-feeling days average ${formatter(Math.abs(delta))} more.`
            : delta < 0
              ? `Lower-feeling days average ${formatter(Math.abs(delta))} more.`
              : "This looks about even so far."}
      </p>
    </div>
  );
}
